import { computed } from 'vue';
import { useStore } from 'vuex';
import { usePageData } from '@composables/usePageData';
import { GET_ALL_PRODUCTS_DATA } from '../types/getters';

function getProducts(store) {
  return computed(() => store.getters[`productStore/${GET_ALL_PRODUCTS_DATA}`]);
}

/**
 * @returns {import('vue').ComputedRef<Product | undefined>}
 */
export function usePageProductData() {
  // TODO remove computed
  return computed(() => usePageData().product?.product);
}

/**
 * @param {ProductId} [productId]
 * @returns {import('vue').ComputedRef<Product | undefined>}
 */
export function useProductData(productId) {
  if (!productId) {
    return usePageProductData();
  }

  const store = useStore();
  const products = getProducts(store);
  const product = computed(() => products.value[productId]);

  return product;
}
